<script>
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import DrugFormsList from '../DrugFormsList/DrugFormsList.svelte';
  
  let {
    headingTextTemplate,
    nameHeaderText = $bindable(),
    otherFormsHeading,
    formHeaderText,
    strengthHeaderText,
    pricesStartingAtLabel,
    seePricingText,
    linkTemplate,
    headingLevel = 'h3',
    drugs,
    showPrices = false,
    dataTestId = 'similar-drug-table',
  } = $props();

  nameHeaderText = headingTextTemplate ? headingTextTemplate : nameHeaderText;
</script>

{#if headingLevel === 'h3'}
  <h3 class="md:px-0 font-medium mb-2 lg:text-lg">{nameHeaderText}</h3>
{/if}
{#if headingLevel === 'h2'}
  <h2 class="text-lg font-medium mb-4 md:px-0 md:text-xl lg:text-2xl text-blue-navy">{nameHeaderText}</h2>
{/if}

<div data-testid={dataTestId}>
  {#each drugs as drug}
    {#if showPrices}
      <BaseLink dataTestId="{dataTestId}-row" url={linkTemplate.replace(/{{SLUG}}/, drug.slug)} target={'_self'}>
        <div class="bg-white shadow-y-sm mb-4 w-full rounded-lg flex justify-between">
          <div class="p-3 lg:p-4 w-full">
            <BaseHeading headingLevel={headingLevel === 'h3' ? 'h4' : 'h3'} className="mb-2 leading-none">
              <span
                class="md:text-lg lg:text-xl font-medium text-blue-cerulean hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:underline active:text-blue-darkish"
                >{drug.text}</span
              >
            </BaseHeading>
            {#if drug.price}
              <div
                class="text-sm lg:text-base text-gray-charcoal"
                data-testid="{dataTestId}-pricing-tile-supplemental-info"
              >
                {#if drug.price.form && drug.price.strength}
                  <span>{drug.price.form},</span>
                  <span>{drug.price.strength}</span>
                  {#if drug.price.quantity}
                    <span>, {drug.price.quantity}</span>
                  {/if}
                {/if}
              </div>
            {/if}

            {#if Object.keys(drug.forms).length > 1}
              <p class="mt-4 font-medium">{otherFormsHeading}:</p>
              <DrugFormsList forms={drug.forms} {formHeaderText} {strengthHeaderText} evenodd={false} />
            {/if}
          </div>
          <div
            class="text-center w-30 min-w-30 sm:w-36 sm:min-w-36 md:w-46 md:min-w-46 lg:w-53 lg:min-w-53 p-4 rounded-r-lg bg-blue-very-light flex flex-col justify-center"
          >
            {#if drug.price && drug.price.price}
              <p class="leading-tight mb-1 text-sm md:text-base">{pricesStartingAtLabel}</p>
              <span class="sm:text-lg md:text-2xl font-medium text-blue-cerulean leading-none">
                <sup class="text-2xs md:text-sm -top-2">$</sup>
                {drug.price.price}
              </span>
            {:else}
              <span class="md:text-lg font-medium text-blue-cerulean">{seePricingText}</span>
            {/if}
          </div>
        </div>
      </BaseLink>
    {/if}

    {#if !showPrices}
      <DrugFormsList forms={drug.forms} {formHeaderText} {strengthHeaderText} evenodd={true} />
    {/if}
  {/each}
</div>
